"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupType = void 0;
// Copied from @zapier/auth/src/types.ts so we
// don't have to include the entire @zapier/auth
// package and all of its dependencies
var SignupType;
(function (SignupType) {
    SignupType["oneTap"] = "one-tap";
    SignupType["googleOneTap"] = "google-one-tap";
    SignupType["sso"] = "sso";
    SignupType["googleSso"] = "google-sso";
    SignupType["direct"] = "direct";
    SignupType["facebookSso"] = "facebook-sso";
    SignupType["flab"] = "flab-abs";
    SignupType["flabSso"] = "flab-sso";
    SignupType["microsoftSso"] = "microsoft-sso";
})(SignupType = exports.SignupType || (exports.SignupType = {}));
